import { render } from "./process_id.vue?vue&type=template&id=6e5f220d&scoped=true"
import script from "./process_id.vue?vue&type=script&lang=js"
export * from "./process_id.vue?vue&type=script&lang=js"

import "./process_id.vue?vue&type=style&index=0&id=6e5f220d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5f220d"]])

export default __exports__